import React from "react"
import { Dashboard } from "../modules/Dashboard/DashboardPage"

export function DashboardPage() {
	return <Dashboard />
}
